// package
import { Fragment, useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
  Form,
  Spinner,
} from "react-bootstrap";
import AmlHashForm from "aml-hash-form";

// component
import PageBreadcrumb from "elements/System/PageBreadcrumb";
import AgDelete from "elements/System/AgDelete";
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";

export default function LinkForm() {
  // const
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let mode = searchParams.get("mode");
  let id = searchParams.get("id");

  // state
  const [process, setProcess] = useState<any>({ result: 100 });
  const [confirm, setConfirm] = useState<any>({ id: null, type: null });
  const [submit, setSubmit] = useState<any>("");
  const [resultList, setResultList] = useState<any>(null);
  const [permission] = useState(common.getUserPermission());

  // form
  const formFields = {
    name: { validate: ["req#Name is required"] },
    url: { validate: ["req#Url is required"] },
    imageUrl: { validate: [""] },
    sort: { validate: [""] },
  };

  const {
    fields,
    errors,
    handleChange,
    handleSubmit,
    setValue,
    setMultiValue,
  } = AmlHashForm(formFields);

  // effect
  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200);
    }
  }, [mode]);

  // api
  const getData = () => {
    processState("result", 100);
    let data: any = {
      url: `admin/link/${id}`,
      method: "GET",
    };
    api.call(data, (res: any) => {
      processState("result", res.status);
      if (res.status === 200) {
        let result = res.data;
        setResultList(result);
        setMultiValue({
          name: result.name || "",
          url: result.url || "",
          imageUrl: result.imageUrl || "",
          sort: result.sort || "",
        });
      }
    });
  };

  const save = () => {
    let data = common.formPayload(fields, []);

    let param = {
      url: id ? `admin/link/${id}` : `admin/link/`,
      method: id ? "PUT" : "POST",
      body: data,
    };

    api.call(param, (res: any) => {
      if (res.status === 200) {
        common.notify("S", "Link updated successfully");
        if (id) {
          navigate(`/link/form?id=${id}&mode=view`);
          processState("result", 100);
          getData();
        } else {
          navigate(`/link/list`);
        }
      } else {
        common.notify("E", res?.data.error);
      }
      setSubmit("");
    });
  };

  const deleteLocality = () => {
    let data: any = {
      url: `admin/link/${confirm.id}`,
      method: "DELETE",
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        setConfirm({ id: null, type: "" });
        common.notify("S", "Link deleted successfully");
        navigate(`/link/list`);
      } else {
        common.notify("E", res.error);
      }
    });
  };

  // events
  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    if (isValid) {
      setSubmit("submit");
      save();
    }
  };

  const deleteCallBack = (isDelete: boolean) => {
    if (isDelete) {
      deleteLocality();
    } else {
      setConfirm({ id: null, type: "" });
    }
  };

  // callback
  const onAgCallBack = (status: any) => {
    getData();
  };

  // support
  const processState = (label: any, value: any) => {
    setProcess((prev: any) => ({
      ...prev,
      [label]: value,
    }));
  };

  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          { label: "Links", path: "/link/list" },
          { label: "Links Form", path: "/link/list", active: true },
        ]}
        title={"Links Form"}
      />
      {process.result != 200 ? (
        <AgStatus
          process={process.result}
          message={{
            100: "Loading... Please wait!",
            404: "Something went wrong! Please Refresh Again",
          }}
          button={{ 400: "Refresh", 404: "Refresh" }}
          size="l"
          onAgCallBack={onAgCallBack}
        />
      ) : (
        <Fragment>
          {mode != "view" ? (
            <Fragment>
              {" "}
              <Row>
                <Col xl={12} lg={12}>
                  <Card>
                    <Card.Body className="py-1 px-1 border-bottom border-light">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="float-start">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Back</Tooltip>}
                          >
                            <Link
                              to="/link/list"
                              className="text-reset fs-20 p-1 d-inline-block"
                            >
                              <i
                                className="ri-arrow-left-s-line pe-2"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Link>
                          </OverlayTrigger>
                          <label className="form-check-label fs-16">
                            {id ? "Edit" : "Add"} Links
                          </label>
                        </div>
                        <div id="tooltips-container d-flex align-items-center">
                          <div className="d-flex flex-wrap gap-2">
                            <Button
                              variant="secondary"
                              onClick={() => {
                                navigate("/link/list");
                              }}
                              disabled={submit === "submit"}
                            >
                              <i className=" ri-arrow-go-back-line me-1" />
                              Cancel
                            </Button>
                            <Button
                              variant="primary"
                              onClick={onSubmit}
                              disabled={submit === "submit"}
                            >
                              {submit === "submit" ? (
                                <>
                                  <Spinner
                                    className="spinner-border-sm me-1"
                                    color="white"
                                  />
                                  Processing...
                                </>
                              ) : (
                                <>
                                  <i className="ri-save-line" /> Save
                                </>
                              )}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card>
                    <Card.Body>
                      <Form>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter Link Name"
                                value={fields.name}
                                onChange={handleChange}
                                isInvalid={errors.name ? true : false}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Url</Form.Label>
                              <Form.Control
                                type="text"
                                name="url"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter Url"
                                value={fields.url}
                                onChange={handleChange}
                                isInvalid={errors.url ? true : false}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.url}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Image Url</Form.Label>
                              <Form.Control
                                type="text"
                                name="imageUrl"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter image Url"
                                value={fields.imageUrl}
                                onChange={handleChange}
                                isInvalid={errors.imageUrl ? true : false}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.imageUrl}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Sort</Form.Label>
                              <Form.Control
                                type="text"
                                name="sort"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter sort number"
                                value={fields.sort}
                                onChange={handleChange}
                                isInvalid={errors.sort ? true : false}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.sort}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Fragment>
          ) : (
            <Fragment>
              <Row>
                <Col xl={12} lg={12}>
                  <Card>
                    <Card.Body className="py-1 px-1 border-bottom border-light">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="float-start">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Back</Tooltip>}
                          >
                            <Link
                              to="/link/list"
                              className="text-reset fs-20 p-1 d-inline-block"
                            >
                              <i
                                className="ri-arrow-left-s-line pe-2"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Link>
                          </OverlayTrigger>
                          <label className="form-check-label fs-16">
                            Links Information
                          </label>
                        </div>
                        {permission.includes("lku") && <div id="tooltips-container d-flex align-items-center">
                          <div className="d-flex flex-wrap gap-2">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip id="">Edit</Tooltip>}
                            >
                              <Button
                                className="btn btn-light"
                                onClick={() => {
                                  navigate(`/link/form?id=${id}&mode=edit`);
                                }}
                              >
                                <i
                                  className="ri-edit-2-line"
                                  data-bs-container="#tooltips-container"
                                  data-bs-toggle="tooltip"
                                />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </div>}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Card>
                    <Card.Body>
                      <Form>
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Name</Form.Label>
                              <p className="text-muted fs-14">
                                {resultList.name || "-"}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Url</Form.Label>
                              <p className="text-muted fs-14">
                                <Link
                                  to={resultList.url ? resultList.url : "#"}
                                  target="_blank"
                                >
                                  {resultList.url ? resultList.url : ""}
                                </Link>
                              </p>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Image Url</Form.Label>
                              <p className="text-muted fs-14">
                                <Link
                                  to={resultList.imageUrl ? resultList.imageUrl : "#"}
                                  target="_blank"
                                >
                                  {resultList.imageUrl ? resultList.imageUrl : "-"}
                                </Link>
                              </p>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Sort</Form.Label>
                              <p className="text-muted fs-14">
                                {resultList.sort || "-"}
                              </p>
                            </Form.Group>
                          </Col>
                          {permission.includes("lkd") && <Col md={4}>
                            <Button
                              variant="danger"
                              size="sm"
                              className="me-1 d-felx align-items-center"
                              onClick={() => setConfirm({ id: id })}
                            >
                              <i className="ri-delete-bin-line fs-16" />
                              <span className="ms-1">
                                Permanently Delete Links
                              </span>
                            </Button>
                          </Col>}
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Fragment>
          )}
        </Fragment>
      )}
      {/* Delete confirmation */}
      {confirm.id && (
        <AgDelete type="delete" onAgDeleteCallBack={deleteCallBack} />
      )}
    </Fragment>
  );
}
